const pad0 = x => x.toString().padStart(2, "0");

const formatDate = (date, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        // date is string
        // separate date and time
        let [d, t] = date.split(" ");

        let parts = d.split("-");
        if (parts.length < 3) {
            console.log("formatDate: wrong date", date, parts);
            return '';
        }
        if (parts[0].length == 4) { // year comes first
            dt = new Date(date);
        } else {
            dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}` + (t ? ` ${t}` : ''));
        }
    }

    let dateStr = '';
    for (let i = 0; i < format.length; i++) {
        if (format[i] === 'y') {
            dateStr += dt.getFullYear();
        } else if (format[i] === 'm') {
            dateStr += pad0(dt.getMonth() + 1);
        } else if (format[i] === 'd') {
            dateStr += pad0(dt.getDate());
        } else if (format[i] === 'H') {
            dateStr += pad0(dt.getHours());
        } else if (format[i] === 'i') {
            dateStr += pad0(dt.getMinutes());
        } else if (format[i] === 's') {
            dateStr += pad0(dt.getSeconds());
        } else {
            dateStr += format[i];
        }
    }
    return dateStr;
}

const dateAfter = (date = 'today', days = 1, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        if (date == 'today') {
            dt = new Date();
        } else {
            dt = new Date(date);
        }
    }
    dt.setDate(dt.getDate() + days);
    return formatDate(dt, format);
}

const setTransferStartDate = (dates) => {
    let startDate = '';
    let dt = new Date();
    let time = formatDate(dt, 'H:s');
    if (time > '22:00') {
        // if time is passed 10 then transfer starts the day after next date
        startDate = dateAfter("today", 2);
    } else {
        // transfer starts next date
        startDate = dateAfter("today", 1);
    }

    if (dates && startDate < dates.opening_date) {
        startDate = dates.opening_date;
    }

    return startDate;
}

// const discountPrice = (price, discount) => {
//     let disc_price = price - ((discount * price) / 100);
//     // fix "toFixed" rounding problem
//     return Number(Math.round(disc_price + 'e2') + 'e-2').toFixed(2);
// };

const scrollToElement = (element_id, topOffset = 0) => {
    setTimeout(function () {
        let element = document.getElementById(element_id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    }, 100);
}

const elementExist = (element_id) => {
    let element = document.getElementById(element_id);
    return !!element;
}

const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}


const isValidEmail = email => /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}/.test(email);
const isNumeric = txt => /^[0-9]+$/.test(txt);


const upCaseStr = str => {
    if (!str) {
        return "";
    }
    //let arr = [['Α', 'Ά'], ['Ε', 'Έ'], ['Η', 'Ή'], ['Ι', 'Ί'], ['Ι', 'Ϊ'], ['Ο', 'Ό'], ['Υ', 'Ύ'], ['Υ', 'Ϋ'], ['Ω', 'Ώ']];
    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}


const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};

// Google tag manager event
const setGtagEvent = (event, transaction_id, total_price, email, payment_type, items) => {
    console.log("setGtagEvent");
    console.log("ITEMS", items);

    let gtag = {
        "event": event,
        "ecommerce": {
            "transaction_id": transaction_id,
            "affiliation": "Watercity Online Tickets",
            "value": +total_price.toFixed(2),
            "currency": "EUR",
            "items": items,
        }
    }
    console.log("GTAG", gtag);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtag);
}

export {
    formatDate,
    dateAfter,
    setTransferStartDate,
    scrollToElement,
    setFocusTo,
    elementExist,
    isValidEmail,
    isNumeric,
    upCaseStr,
    copyObject,
    setGtagEvent,
}